/**
 * The class list for the report/list panes. A LEAF module on purpose: the shell's skeleton needs it and stays
 * in the entry bundle, so importing it from `layout.tsx` drags TitleSection and the nav stack along (+8.5 KB).
 *
 * ON A PHONE THIS IS THE SCROLLER, and that is what makes sticky work: it is the nearest scrollport to a
 * screen's content and it scrolls the axis sticky needs, so a header inside pins with nothing measured.
 * Desktop keeps the document scroll, where `clip` beside `visible` clips sideways without becoming one.
 */
export const SCROLLABLE_AREA_CLASS =
  'scrollable-area min-h-0 flex-1 overflow-x-clip max-md:overflow-y-auto md:overflow-y-visible print:h-auto print:overflow-visible'
